module.exports = __webpack_public_path__ + "media/bootstrap-icons/egg-fried-267fb150.svg";